<template>
  <el-form
    :model="form"
    :rules="rules"
    :validateOnRuleChange="false"
    @submit.prevent.native
    ref="form"
  >
    <el-collapse-transition>
      <div class="block p-b" v-if="serverError">
        <el-alert
          :title="$t('SHARED__SERVER_ERROR')"
          type="error"
          effect="dark"
          key="alert-success"
        >
        </el-alert>
      </div>
    </el-collapse-transition>
    <el-form-item
      prop="firstname"
      :error="violations.firstname"
      class="block with-control-label"
    >
      <el-input
        v-model="form.firstname"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        id="firstname"
      >
        <label
          for="firstname"
          slot="prepend"
          :class="[isLabelActive('firstname') ? 'active' : '']"
          >{{ $t("SHARED__FIRSTNAME_PLACEHOLDER") }}<sup>*</sup></label
        >
      </el-input>
    </el-form-item>

    <el-form-item
      prop="lastname"
      :error="violations.lastname"
      class="block with-control-label"
    >
      <el-input
        v-model="form.lastname"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        id="lastname"
      >
        <label
          for="lastname"
          slot="prepend"
          :class="[isLabelActive('lastname') ? 'active' : '']"
          >{{ $t("SHARED__LASTNAME_PLACEHOLDER") }}<sup>*</sup></label
        >
      </el-input>
    </el-form-item>

    <el-form-item
      prop="email"
      :error="violations.email"
      class="block with-control-label"
    >
      <el-input
        v-model="form.email"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        id="email"
      >
        <label
          for="email"
          slot="prepend"
          :class="[isLabelActive('email') ? 'active' : '']"
          >{{ $t("SHARED__EMAIL_PLACEHOLDER") }}<sup>*</sup></label
        >
      </el-input>
    </el-form-item>

    <el-form-item
      prop="zip"
      :error="violations.zip"
      class="block with-control-label"
    >
      <el-input
        v-model="form.zip"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        id="zip"
      >
        <label
          for="zip"
          slot="prepend"
          :class="[isLabelActive('zip') ? 'active' : '']"
          >{{ $t("SHARED__PC_PLACEHOLDER") }}<sup>*</sup></label
        >
      </el-input>
    </el-form-item>

    <el-form-item prop="isSubscribedToContestMessages">
      <el-checkbox
        v-model="form.isSubscribedToContestMessages"
        name="isSubscribedToContestMessages"
        >{{ $t("SHARED__AGREEMENT") }}<br />{{ $t("SHARED__OPTIN_TRANSAT")
        }}<sup>*</sup></el-checkbox
      >
    </el-form-item>

    <el-form-item v-show="false" style="margin-top: 45px">
      <el-checkbox
        v-model="form.isSubscribedToAirTransatMessages"
        name="isSubscribedToAirTransatMessages"
        >{{ $t("SHARED__OPTIN_TRANSAT") }}</el-checkbox
      >
    </el-form-item>

    <!--    <el-form-item style="margin-top: 45px">
      <el-checkbox
        v-model="form.isSubscribedToIdcMessages"
        name="isSubscribedToIdcMessages"
        >{{ $t("SHARED__OPTIN_IDC") }}</el-checkbox
      >
    </el-form-item>-->

    <el-form-item class="block p-b">
      <el-button
        type="primary"
        @click="recaptcha"
        :disabled="isFormSubmitted"
        class="w100"
      >
        {{ $t("SHARED__I_WANT_WIN") }}<i class="fas fa-plane"></i>
      </el-button>
    </el-form-item>

    <confirm-email-dialog
      :dialog-visible="!!suggestedEmail"
      :suggested-email="suggestedEmail"
      :original-email="form.email"
      @confirm="confirmEmail"
      @close="
        suggestedEmail = null
        isFormSubmitted = false
      "
    ></confirm-email-dialog>
  </el-form>
</template>

<script>
import to from "await-to-js"
import { createNamespacedHelpers } from "vuex"

import UserService from "../../services/api/UserService"
import { getDestinationResource } from "../../helpers/string"
import { getEmailSuggestions } from "../../services/mailcheck"
import ConfirmEmailDialog from "../Lib/ConfirmEmailDialog"

const { mapState, mapMutations } = createNamespacedHelpers("app")
const userService = new UserService()

export default {
  name: "RegistrationForm",
  components: {
    ConfirmEmailDialog
  },
  data() {
    return {
      loading: false,
      inFocus: null,
      form: {
        firstname: null,
        lastname: null,
        email: null,
        zip: null,
        isSubscribedToContestMessages: false,
        isSubscribedToAirTransatMessages: false,
        isSubscribedToIdcMessages: false
      },
      isFormSubmitted: false,
      violations: {},
      serverError: false,
      suggestedEmail: null,
      recaptchaToken: null
    }
  },
  computed: {
    ...mapState(["selectedDestination"]),
    rules() {
      var validateIsSubscribedToContestMessages = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("SHARED__OPTIN_VALIDATION")))
        } else {
          callback()
        }
      }
      return {
        email: [
          {
            required: true,
            pattern: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            message: this.$t("SHARED__EMAIL_VALIDATION"),
            trigger: "blur"
          }
        ],
        zip: [
          {
            required: true,
            pattern: /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]\s?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
            message: this.$t("SHARED__POSTAL_CODE_VALIDATION"),
            trigger: "blur"
          }
        ],
        firstname: [
          {
            required: true,
            min: 2,
            message: this.$t("SHARED__MIN_LENGTH_VALIDATION").replace("%d", 2),
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,
            min: 2,
            message: this.$t("SHARED__MIN_LENGTH_VALIDATION").replace("%d", 2),
            trigger: "blur"
          }
        ],
        isSubscribedToContestMessages: [
          {
            type: "boolean",
            validator: validateIsSubscribedToContestMessages
          }
        ]
      }
    }
  },
  watch: {
    "form.email"(val) {
      this.form.email = val.trim()
    },
    "form.zip"(val) {
      this.form.zip = val.trim()
    },
    "form.isSubscribedToContestMessages"(val) {
      this.form.isSubscribedToAirTransatMessages = val
    }
  },
  methods: {
    ...mapMutations(["setUser"]),
    createUser(userData) {
      return userService.create(userData)
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(async valid => {
          if (valid) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    async recaptcha() {
      await this.$recaptchaLoaded()

      this.recaptchaToken = await this.$recaptcha("login")

      return this.submit()
    },
    async submit() {
      if (this.isFormSubmitted) return
      this.violations = {}
      this.serverError = false
      const isFormValid = await this.validate()
      if (!isFormValid) {
        return false
      }

      const suggestion = await getEmailSuggestions(this.form.email)
      if (suggestion) {
        this.suggestedEmail = suggestion.full
      } else {
        return this.createPlane()
      }
    },
    async createPlane() {
      this.isFormSubmitted = true
      this.loading = true
      let err, user
      ;[err, user] = await to(
        this.createUser({
          destination: getDestinationResource(this.selectedDestination.id),
          ...this.form,
          captcha: this.recaptchaToken
        })
      )

      if (err) {
        this.isFormSubmitted = false
        this.loading = false
        if (err.response.status !== 500) {
          const violations = err.response.data.violations
          violations.forEach(violation => {
            this.violations[violation.propertyPath] = violation.message
          })
        } else {
          this.serverError = true
        }

        return
      }

      // this.setUser(user)
      this.$gtag.event("Plane")
      if (window.fbq) {
        window.fbq(
          "trackSingleCustom",
          "776918872375668",
          "Inscrit VoyageDeReve"
        )
      }
      this.isFormSubmitted = false
      this.loading = false
      this.$router.replace({
        name: "status",
        query: { t: user.token, u: user.id }
      })
    },
    confirmEmail(confirmedEmail) {
      this.suggestedEmail = null
      this.form.email = confirmedEmail
      this.createPlane()
    },
    isLabelActive(field) {
      return this.inFocus === field || this.form[field]
    },
    handleInputFocus(evt) {
      this.inFocus = evt.target.id
    },
    handleInputBlur(evt) {
      const id = evt.target.id
      if (this.inFocus === id) {
        this.inFocus = null
      }
    }
  }
}
</script>

<style scoped></style>
